import {
  Identifiable,
  Milestone,
  Project,
  ProjectSynthesis,
  Task,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = {
  comingMilestones: Identifiable<Milestone>[];
  comingTasks: Identifiable<Task>[];
  delayedMilestones: Identifiable<Milestone>[];
  finishedMilestones: Identifiable<Milestone>[];
  delayedTasksOfProject: Identifiable<Task>[];
  comingElementsNbr: number;
  delayedElementsNbr: number;
  nbrOfFinishedMilestones: number;
  nbrOfFinishedTasks: number;
  nbrOfHoursOfAccomplishedWork: number;
  nbrOfHoursOfDelayedWork: number;
  nbrOfHoursOfOpenedWork: number;
  nbrTotalOfMilestones: number;
  nbrTotalOfTasksInProject: number;
  proportionOfAccomplishedWork: number;
  proportionOfDelayedWork: number;
  proportionOfOpenedWork: number;
  totalSumOfTimeAllocatedOnTheProject: number;
  totalOfTimesSpentInProject: number;
  totalOfRemainingTimeInProject: number;
};

function getProjectSynthesis(httpClient: HttpClient) {
  return (project: Identifiable<Project>) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/projects/${project.uuid}?projection=synthesis`,
        method: HttpMethods.GET,
      })
      .then((res) => ({
        upComingMilestones: res.comingMilestones,
        upComingTasks: res.comingTasks,
        delayedMilestones: res.delayedMilestones,
        delayedTasks: res.delayedTasksOfProject,
        upComingElementsNbr: res.comingElementsNbr,
        delayedElementsNbr: res.delayedElementsNbr,
        doneMilestonesNbr: res.nbrOfFinishedMilestones,
        doneTasksNbr: res.nbrOfFinishedTasks,
        workedHours: res.nbrOfHoursOfAccomplishedWork,
        delayedWorkHours: res.nbrOfHoursOfDelayedWork,
        openedWorkHours: res.nbrOfHoursOfOpenedWork,
        milestonesNbr: res.nbrTotalOfMilestones,
        tasksNbr: res.nbrTotalOfTasksInProject,
        proportionOfAccomplishedWork: res.proportionOfAccomplishedWork,
        proportionOfDelayedWork: res.proportionOfDelayedWork,
        proportionOfOpenedWork: res.proportionOfOpenedWork,
        allocatedTime: res.totalSumOfTimeAllocatedOnTheProject,
        finishedMilestones: res.finishedMilestones,
        totalOfTimesSpentInProject: res.totalOfTimesSpentInProject,
        totalOfRemainingTimeInProject: res.totalOfRemainingTimeInProject,
      }));
}

export { getProjectSynthesis };
